import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';
import { ETATS_CYCLE, MODES_REGLEMENTS } from '@/constants';
import { ModeReglementContext, RegieContext } from '@/contexts';

const CyclesListeTableHeader = (props) => {
  const { regies, selectedRegie } = React.useContext(RegieContext);
  const { regieModesReglement } = React.useContext(ModeReglementContext);

  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn =
    _.size(_.find(regies, { identifiant: selectedRegie })?.logicielsFacturier) <= 1;

  const hasPrelevement = React.useMemo(
    () => _.some(regieModesReglement, { code: MODES_REGLEMENTS.PRELEVEMENT }),
    [regieModesReglement],
  );

  return (
    <>
      <ListeTable.Column
        {...props}
        name="dateIncorporation"
        sortable
        style={{ width: 175 }}
        verticalAlign="middle"
      >
        Date
        <br />
        d&apos;incorporation
      </ListeTable.Column>
      <ListeTable.Column {...props} name="titre" verticalAlign="middle" sortable>
        Cycle et date d&apos;émission
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column
          {...props}
          name="logicielFacturier"
          verticalAlign="middle"
          style={{ width: 90 }}
        >
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column
        {...props}
        name="dateLimite"
        sortable
        style={{ width: 175 }}
        verticalAlign="middle"
      >
        Date limite
        <br />
        d&apos;encaissement
      </ListeTable.Column>
      <ListeTable.Column
        {...props}
        name="nombreFactures"
        sortable
        style={{ width: 120 }}
        verticalAlign="middle"
      >
        Nombre
        <br />
        factures
      </ListeTable.Column>
      <ListeTable.Column
        {...props}
        name="montant"
        sortable
        style={{ width: 140 }}
        verticalAlign="middle"
      >
        Montant
        <br />
        cycle
      </ListeTable.Column>
      {hasPrelevement && (
        <>
          <ListeTable.Column
            {...props}
            name="datePrelevement"
            style={{ width: 175 }}
            verticalAlign="middle"
          >
            Date de
            <br />
            prélèvement
          </ListeTable.Column>
          <ListeTable.Column
            {...props}
            name="nombreFacturesPrelevees"
            style={{ width: 120 }}
            verticalAlign="middle"
          >
            Nombre
            <br />
            factures
            <br />
            prélevées
          </ListeTable.Column>
        </>
      )}
      <ListeTable.Column
        {...props}
        name="montantEncaisse"
        sortable
        style={{ width: 140 }}
        verticalAlign="middle"
      >
        Montant
        <br />
        encaissé
      </ListeTable.Column>
      <ListeTable.Column
        {...props}
        name="etat"
        verticalAlign="middle"
        style={{ width: 200 }}
        type="string"
        filtersDefaultActive="DANS_LISTE"
        filtersValues={{
          DANS_LISTE: [
            ETATS_CYCLE.ENCAISSEMENT_EN_COURS,
            ETATS_CYCLE.TRANSFERT_IMPAYES,
            ETATS_CYCLE.ENCAISSEMENT_TERMINE,
          ],
        }}
      >
        État du cycle
      </ListeTable.Column>
    </>
  );
};

export default CyclesListeTableHeader;
